import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown as faAngleDownRegular } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { faAngleDown as faAngleDownSolid } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';

export const DropdownTextHeader = ({
  selection,
  header = false,
}: {
  selection: string;
  header?: boolean;
}) => {
  return (
    <>
      {selection}

      <FontAwesomeIcon icon={header ? faAngleDownSolid : faAngleDownRegular} />
    </>
  );
};
